export default __webpack_public_path__ + "static/Roll-Off-Dumpsters-3fae22d8b433e9ae8ce2d542edc97b84.jpg";